import { TYPE_IMAGE } from '@wix/communities-blog-client-common/dist/src/services/wix-media/media-types';
import { requestCredentials } from '@wix/communities-blog-client-common/dist/src/services/wix-media/request-url';
import { uploadFile } from '@wix/communities-blog-client-common/dist/src/services/wix-media/upload-file';
import { setIsLoading } from '../store/is-loading/is-loading-actions';
import { uploadStarted } from './upload-started';
import { uploadEnded } from './upload-ended';
import { createPromisifiedAction } from '../actions-promisifier/create-promisified-action';

export const uploadImage = (file, imageData) => (dispatch, getState, { request }) => {
  const id = new Date().getTime();
  const stopLoading = data => {
    dispatch(setIsLoading('upload', id, false));
    return data;
  };
  dispatch(setIsLoading('upload', id, true));

  dispatch(uploadStarted({ type: TYPE_IMAGE }));
  return requestCredentials(request, TYPE_IMAGE)
    .then(
      credentials =>
        uploadFile({
          file: file.type !== 'image/gif' ? imageData.dataUrl : file,
          name: file.name,
          type: TYPE_IMAGE,
          credentials,
        }).promise,
    )
    .then(uploadedImageData => {
      dispatch(uploadEnded({ type: TYPE_IMAGE }));
      return uploadedImageData;
    })
    .then(stopLoading)
    .catch(stopLoading);
};

export const uploadImagePromisified = createPromisifiedAction(
  uploadImage,
  imageData => imageData,
  response => response.status,
);
